<div class="sh-page-header">
    <header class="sh-page-header__head">
        <div class="sh-page-header__head__info">
            <h3 class="sh-page-title--subsection sh-icon-title sh-clear-margin">
                <svg sh-icon class="sh-icon-title__icon" aria-hidden="true" [name]="icon"></svg>
                {{ title }}
            </h3>
        </div>

        <div *ngIf="navigationItem" class="sh-page-header__head__actions">
            <sh-icon-link [item]="navigationItem" class="sh-truncate-text"></sh-icon-link>
        </div>
    </header>
</div>
